<div class="category-item" [class.selected]="category.selected"  [class.extraCategoryDiv]="hasFreeCategory">
<!-- lock feature in case we need to lock categories
    <div [class.display-none]="recipe.unlocked" class = "recipe-overlay">
        <img src="/assets/base_icons/icon_lock.svg">
    </div>
-->
    <!-- <img class="category-img" src="/assets/pictos/recipes/{{recipe.picto!}}.svg" alt={{recipe.title!}}> -->
    <p [class.extraCategoryP]="hasFreeCategory">{{category.getTitle(authSvc.User.accountSettings.language)}}</p> 
</div>
